/* eslint-disable no-console */
import wrapper from 'wrapper';
import AnimationToggle from '../animation-toggle/animation-toggle';
import Carousel from '../carousel/carousel';

const { includeName } = wrapper.getConfig();

const main = () => {
    new Carousel();
    new AnimationToggle();

    wrapper.select(`.carousel__wrapper--${includeName}.no-js`).classList.remove('no-js');

    wrapper.markPageAsLoaded();
};

export default main;
